"use client";

import React from 'react';
import { EnvironmentFooter } from './environment-footer';

export function DevelopmentTools() {
  // Always show the environment footer for now (enabled for all environments)
  return <EnvironmentFooter />;
}
